import { render } from "./portofiol.vue?vue&type=template&id=8ebf8e26"
import script from "./portofiol.vue?vue&type=script&lang=js"
export * from "./portofiol.vue?vue&type=script&lang=js"

import "./portofiol.vue?vue&type=style&index=0&id=8ebf8e26&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__